//@flow
import * as React from 'react';
import { Position } from '@locus-taxy/neo-ui';
import { useTranslation } from 'react-i18next';
import FilterListBuilder from 'common/models/helpers/FilterListBuilder';

import {
    outletMasterContainerFactory,
    DEFAULT_COLUMNS
} from 'common/entity/outletMaster/OutletMasterContainer';
import { PjpNavigationActionsBar } from 'common/entity/pjpMaster/create/PjpNavigationActionsBar';
import { PjpBulkViewEmptyState } from 'common/entity/pjpMaster/create/PjpBulkViewEmptyState';

const COLUMNS = [...DEFAULT_COLUMNS];

COLUMNS[1] = { ...DEFAULT_COLUMNS[1], show: true };

const TerritoryOutletMasterContainer = outletMasterContainerFactory({
    EntityEditViewContainer: null,
    EntityImportContainer: null,
    BulkViewEmptyState: PjpBulkViewEmptyState,
    ActionsBar: PjpNavigationActionsBar,
    COLUMNS
});

export type SelectedOutletsTypes = {
    selectedRows: Array<string>,
    allApplicableFilters: FilterListBuilder,
    allFilteredEntitiesSelected: boolean,
    filteredEntriesCount: number
};

type Props = {
    onNext: SelectedOutletsTypes => void,
    onDismiss: () => void,
    disableSelectAll?: boolean,
    getTdProps: (state: Object, rowInfo: Object) => Object // all are dynamic objects
};

const OutletSelection = (props: Props): React.Node => {
    const { t } = useTranslation('entityManagement');
    return (
        <Position
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            sx={{
                display: 'flex',
                background: 'white',
                zIndex: 16 // Greater then entity sidebar
            }}
        >
            <TerritoryOutletMasterContainer
                title={t('createTerritory.outletMasterTitle')}
                customActions={{
                    onNext: props.onNext,
                    onCancel: props.onDismiss
                }}
                getTdProps={props.getTdProps}
                enableFilteredEntitiesSelection={!props.disableSelectAll}
            />
        </Position>
    );
};

export default OutletSelection;
